var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.summary)?_c('div',{staticClass:"agent-summary",domProps:{"innerHTML":_vm._s(_vm.summaryHtml)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }